import { render, staticRenderFns } from "./QuotesCustomerTab.vue?vue&type=template&id=0e1af1f9"
import script from "./QuotesCustomerTab.vue?vue&type=script&lang=js"
export * from "./QuotesCustomerTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports